import React, { useState, useEffect } from "react";
import "../../../styles/calculate.css";
import ContractDetailCard from "./contract-detail.jsx"
import StipendCard from "./stipends.jsx"
import BonusCard from "./bonuses.jsx"
import BenefitCard from "./benefits.jsx"
import axios from "axios";
import Swal from 'sweetalert2';
import Loading from 'react-simple-loading';
import { useNavigate, useParams } from "react-router-dom";
import { formatWithCommas } from "../../helpers/common";




const Calculate = () => {
    const navigate = useNavigate();
    const params = useParams();
    const contract_id = params.contract_id;
    const [pageLoad, setPageLoad] = useState(true);
    const [isBtn, setIsBtn] = useState(false);
    const [keyValue, setKeyValue] = useState(0)
    const [contract, setContract] = useState(null);
    const [stipends, setStipends] = useState(null);
    const [benefits, setBenefits] = useState(null);
    const [bonuses, setBonuses] = useState(null);
    const [weeklyTakeHomePay, setWeeklyTakeHomePay] = useState(0.00);
    const [weeklyTakeHomePayPercentage, setWeeklyTakeHomePayPercentage] = useState(0.00);
    const [weeklyStipend, setWeeklyStipend] = useState(0.00);
     

    const [federalTax, setFederalTax] = useState(0.00);
    const [stateTax, setStateTax] = useState(0.00);
    
    const [contractAll, setContractAll] = useState(0.00);
    const [contractTakeHomePay, setContractTakeHomePay] = useState(0.00);
    const [contractTaxes, setContractTaxes] = useState(0.00);
    const [contractStipend, setContractStipend] = useState(0.00);
    const [contractBonus, setContractBonus] = useState(0.00);
    const [contractBenefit, setContractBenefit] = useState(0.00);

    const social_security_tax = 6.2;
    const medicare_tax = 1.45;
    useEffect(() => {

        document.title = 'Roam Pays: Edit Contract ';
        const p1 = getContract();

        const p2 = getStipends();
        const p3 = getBonuses();
        const p4 = getBenefits();


        Promise.all([p1, p2, p3, p4]).then(() => {

            setPageLoad(false);

        });


    }, []);

    useEffect(() => {

        calculateTakeHomeIncome();

    }, [contract, stipends, bonuses, benefits]);

  

    const calculateTakeHomeIncome = async () => {

        if (contract && contract.location_id > 0 && contract.duration > 0 && contract.hourly_rate > 0 && contract.shift_schedule_id > 0) {
setPageLoad(true);

            const hourly_rate = contract.hourly_rate;
            const weekly_hours = contract.days * contract.hours;
            const weekly_pay = weekly_hours * hourly_rate;
            const yearly_pay = (weekly_pay * 52.1429).toFixed(2);

            const total_pay = weekly_hours * contract?.duration * hourly_rate;
            const weekly_stipend = stipends?.reduce((n, { stipend_amount }) => n + stipend_amount, 0);
            
            const total_stipend = weekly_stipend * contract?.duration;
            
            const total_bonus = bonuses?.reduce((n, { bonus_amount }) => n + bonus_amount, 0);
            const total_benefit = benefits?.reduce((n, { benefit_amount }) => n + benefit_amount, 0);

            setContractAll(total_pay + total_stipend + total_bonus + total_benefit);
            setContractStipend(total_stipend);
            setContractBonus(total_bonus);
            setContractBenefit(total_benefit);
            setWeeklyStipend(weekly_stipend);



            axios.post(process.env.REACT_APP_API_URL + "/get-taxes", {
                yearly_pay: yearly_pay,
                location_id: contract.location_id,
            }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {


                    if (response?.data?.status) {
                        const federal_tax = response?.data?.federal_tax;
                        const state_tax = response?.data?.state_tax;
                        setFederalTax(federal_tax);
                        setStateTax(state_tax);
                        const federal_tax_amount = (federal_tax / 100 * weekly_pay)
                        const state_tax_amount = (state_tax / 100 * weekly_pay);
                        const social_security_tax_amount = social_security_tax / 100 * weekly_pay
                        const medicare_tax_amount = medicare_tax / 100 * weekly_pay
                        const weekly_take_home_pay = weekly_pay - federal_tax_amount - state_tax_amount - social_security_tax_amount - medicare_tax_amount;
                        const weekly_taxes = weekly_pay - weekly_take_home_pay;
                        setWeeklyTakeHomePay(weekly_take_home_pay);
                        setContractTaxes(weekly_taxes * contract?.duration)
                        setContractTakeHomePay(total_pay - (weekly_taxes * contract?.duration))

                        const percentage = weekly_take_home_pay * 100 / weekly_pay;
                        setWeeklyTakeHomePayPercentage(percentage.toFixed(2));
setPageLoad(false);
                    }


                })
                .catch(function (error) {
                    if (error.status == 403) navigate("/login")
                    else
                        Swal.fire({ icon: "error", title: "Error", text: error.message });

                });




        }

    }

    const getContract = async () => {

        return new Promise((resolve, reject) => {
            axios.get(process.env.REACT_APP_API_URL + "/get-contract-by-id/" + contract_id, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {

                    if (response?.data?.status) {
                        setContract(response.data.contract);
                    }
                    resolve(1);

                })
                .catch(function (error) {
                    if (error.status == 403) navigate("/login")
                    else
                        Swal.fire({ icon: "error", title: "Error", text: error.message });

                });
        })
    }

    const getStipends = async () => {

        return new Promise((resolve, reject) => {
            axios.get(process.env.REACT_APP_API_URL + "/get-stipends-by-id/" + contract_id, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {

                    if (response?.data?.status) {
                        setStipends(response?.data?.stipends);
                    }
                    resolve(1);


                })
                .catch(function (error) {
                    if (error.status == 403) navigate("/login")
                    else
                        Swal.fire({ icon: "error", title: "Stipends", text: error.message });


                });
        })
    }

    const getBenefits = async (resolve, reject) => {

        return new Promise((resolve, reject) => {
            axios.get(process.env.REACT_APP_API_URL + "/get-benefits-by-id/" + contract_id, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {
                    if (response?.data?.status) {
                        setBenefits(response?.data?.benefits);
                    }
                    resolve(1);

                })
                .catch(function (error) {
                    if (error.status == 403) navigate("/login")
                    else
                        Swal.fire({ icon: "error", title: "Benefits", text: error.message });


                });
        })
    }

    const getBonuses = async (resolve, reject) => {

        return new Promise((resolve, reject) => {
            axios.get(process.env.REACT_APP_API_URL + "/get-bonuses-by-id/" + contract_id, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {
                    setBonuses(response?.data?.bonuses);
                    resolve(1);


                })
                .catch(function (error) {
                    if (error.status == 403) navigate("/login")
                    else
                        Swal.fire({ icon: "error", title: "Error", text: error.message });

                });
        })
    }



    return (
        <>

            <div className="title-box ">
                <div className="flex-equal" >

                    <button className="btn btn-link fs-12 d-flex fd-row align-items-center" onClick={() => navigate("/contract/list")} >

                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.69765 6.99997L8.68205 4.01557L7.65085 2.98438L3.63525 6.99997L7.65085 11.0156L8.68205 9.98438L5.69765 6.99997Z" fill="white" />
                        </svg>
                        <label >Back</label>

                    </button>

                </div>
                <h3 className="flex-equal justify-content-center fs-32 fs-helvetica color-white d-sm-none">Contract</h3>
                <div className="flex-equal justify-content-end" >

                </div>

            </div>


            {pageLoad ?

                <div className="p-32">
                    <Loading color={'#75f'}
                        stroke={'20px'}
                        size={'200px'} />
                </div>

                :
                <>

                    <div className="box g-32" >



                         <div className="fd-column g-8 flex-grow-1">
                            <div className="color-light fs-12" >
                                Weekly Take Home Pay
                            </div>
                            <div className="fd-column g-8" >
                                <div className="w-100 color-white fs-44" >${formatWithCommas(weeklyTakeHomePay+weeklyStipend)}</div>
                                {(contract && contract.location_id > 0 && contract.duration > 0 && contract.hourly_rate > 0 && contract.shift_schedule_id > 0) &&

                                    <div className="fd-row" >

                                        <div className="segment segment-green" style={{ flexBasis: (weeklyTakeHomePay * 100 / (weeklyTakeHomePay+weeklyStipend)).toFixed(0) + "%" }} ></div>
                                        <div className="segment segment-purple" style={{ flexBasis: (weeklyStipend * 100 / (weeklyTakeHomePay+weeklyStipend)).toFixed(0) + "%" }} ></div>

                                    </div>
                                }
                                {(contract && contract.location_id > 0 && contract.duration > 0 && contract.hourly_rate > 0 && contract.shift_schedule_id > 0) &&

                                    <div className="cal-fd-row fs-12 color-white g-8 align-items-center justify-content-space-between" >
                                        <div ><span className="color-green">{weeklyTakeHomePayPercentage}%</span> of your total pay is take-home</div>
                                        <a href={"/contract/details/" + contract_id} className="btn btn-secondary fd-row align-items-center" >
                                            <label className="fs-12">View Breakdown</label>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.30227 6.99997L5.31787 4.01557L6.34907 2.98438L10.3647 6.99997L6.34907 11.0156L5.31787 9.98438L8.30227 6.99997Z" fill="white" />
                                            </svg>
                                        </a>
                                    </div>
                                }
                            </div>


                        </div>

                        <ContractDetailCard getContractDetails={getContract} key={keyValue} federalTax={federalTax} stateTax={stateTax} />

                        <StipendCard getStipendsDetails={getStipends} key={keyValue} />

                        <BonusCard getBonusesDetails={getBonuses} key={keyValue} />

                        <BenefitCard getBenefitsDetails={getBenefits} key={keyValue} />


                        <br />
                        <br />

                    </div>

                </>
            }





        </>


    );
};

export default Calculate;